import { cx } from "@/utils/cx";

type ConnectorRailProps = {
  /** When the rail segment draws in, in seconds. */
  delaySeconds: number;
  reduceMotion: boolean;
  /** Horizontal placement; defaults to centred under the card. */
  className?: string;
};

/** The vertical hairline that joins stacked cards; it draws down from the top. */
export function ConnectorRail({ delaySeconds, reduceMotion, className = "mx-auto" }: ConnectorRailProps) {
  return (
    <div
      className={cx("h-3.5 w-px origin-top bg-white/25", className)}
      style={{ animation: reduceMotion ? undefined : `rail-draw 0.24s ease-out ${delaySeconds}s both` }}
    />
  );
}
